import { render, staticRenderFns } from "./Lodding.vue?vue&type=template&id=24cf190e&scoped=true"
import script from "./Lodding.vue?vue&type=script&lang=js"
export * from "./Lodding.vue?vue&type=script&lang=js"
import style0 from "./Lodding.vue?vue&type=style&index=0&id=24cf190e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cf190e",
  null
  
)

export default component.exports